import { UcoastEl } from '@/scripts/core/UcoastEl'
import {type KlaviyoPopup} from "@/scripts/theme/klaviyo-popup";
import {addToKlaviyoListConfig} from "@/scripts/core/global";
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class KlaviyoForm extends UcoastEl {
  static htmlSelector = 'klaviyo-form'
  form: HTMLFormElement
  submitButton: HTMLButtonElement
  emailInput: HTMLInputElement
  messageDiv: HTMLDivElement
  route: string
  popup?: KlaviyoPopup

  setLoadingStatus(status: boolean) {
    if (status) {
      this.form.setAttribute('disabled', 'true');
      this.submitButton.setAttribute('aria-disabled', 'true')
    } else {
      this.form.setAttribute('disabled', 'false');
      this.submitButton.removeAttribute('aria-disabled')
    }
  }
  showStatusMessage(status: boolean) {
    if (status) {
      this.messageDiv.textContent = this.getSuccessMessage();
      this.messageDiv.classList.remove('hidden');
    } else {
      this.messageDiv.textContent = this.getErrorMessage();
      this.messageDiv.classList.remove('hidden');
    }
  }

  constructor() {
    super()
    this.form = q.rs('form', this)
    this.submitButton = q.rs('[type="submit"]', this)
    this.emailInput = q.rs('[type="email"]', this)
    this.messageDiv = q.rs('.klaviyo-form__message', this)
    this.route = 'https://a.klaviyo.com/client/subscriptions/';
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
    this.popup = q.os<KlaviyoPopup>('klaviyo-popup', this)
  }

  getSuccessMessage(): string {
    const message = this.form.getAttribute('data-success')
    if (!message) throw new Error('Success message not found on form')
    return message;
  }
  getErrorMessage(): string{
    const message = this.form.getAttribute('data-error')
    if (!message) throw new Error('Error message not found on form')
    return message;
  }

  onSubmitHandler(event: Event) {
    event.preventDefault()
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return
    if (this.emailInput.value.length < 1) return

    this.setLoadingStatus(true);

    const formData = new FormData(this.form)

    const config = addToKlaviyoListConfig({
      source: q.rfd(formData, 'source'),
      email: q.rfd(formData, 'email'),
      listId: q.rfd(formData, 'list_id'),
    })
    const companyId = q.rfd(formData, 'company_id');
    const url = new URL(this.route);
    url.searchParams.append('company_id', companyId);

    fetch(url.toString(), config)
      .then((response) => {
        this.showStatusMessage(true);
        this.emailInput.value = ''
        if (response.status === 202) {
          if (this.popup) {
            window.setTimeout(() => {
              this.popup?.hide()
            }, 5000)
          }
        } else {
          this.showStatusMessage(false);
        }
      })
      .catch((e) => {
        console.error(e)
        this.showStatusMessage(false);
      })
      .finally(() => {
        this.setLoadingStatus(false);
      })
  }
}
